let dateToString = (d) => {
  if (!d) {
    return "";
  }
  var yyyy = d.getFullYear().toString();
  var mm = (d.getMonth() + 1).toString();
  var dd = d.getDate().toString();
  return (
    yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0])
  );
};

let datetimeToString = (dt) => {
  if (!dt) {
    dt = new Date();
  }
  let yyyy = dt.getFullYear().toString();
  let mm = (dt.getMonth() + 1).toString();
  let dd = dt.getDate().toString();
  let h = dt.getHours().toString();
  let m = dt.getMinutes().toString();
  let s = dt.getSeconds().toString();
  return (
    yyyy +
    "-" +
    (mm[1] ? mm : "0" + mm[0]) +
    "-" +
    (dd[1] ? dd : "0" + dd[0]) +
    " " +
    (h[1] ? h : "0" + h[0]) +
    ":" +
    (m[1] ? m : "0" + m[0]) +
    ":" +
    (s[1] ? s : "0" + s[0])
  );
};

let stringToDate = (s) => {
  let parts = s.split("-");
  return new Date(parts[0], parseInt(parts[1], 10) - 1, parts[2]);
};

export { dateToString, datetimeToString, stringToDate };
